// extracted by mini-css-extract-plugin
module.exports = {"container":"FreeTrialPanel_CreateChannel_container__1-7Jf","name":"FreeTrialPanel_CreateChannel_name__RHlbt"};